import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { BackgroundProgress, SlideImageProgress } from "@vida/surf-core";

type SurfEditorActivityState = {
  message: string | null;
  progress: BackgroundProgress | SlideImageProgress | null;
  setMessage: (message: string | null) => void;
  setProgress: (progress: BackgroundProgress | SlideImageProgress | null) => void;
};

const SurfEditorActivityContext = createContext<SurfEditorActivityState | null>(null);

export function SurfEditorActivityProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);
  const [progress, setProgress] = useState<BackgroundProgress | SlideImageProgress | null>(null);
  const value = useMemo(
    () => ({ message, progress, setMessage, setProgress }),
    [message, progress],
  );
  return (
    <SurfEditorActivityContext.Provider value={value}>{children}</SurfEditorActivityContext.Provider>
  );
}

export function useSurfEditorActivity(): SurfEditorActivityState {
  const ctx = useContext(SurfEditorActivityContext);
  if (!ctx) {
    return {
      message: null,
      progress: null,
      setMessage: () => {},
      setProgress: () => {},
    };
  }
  return ctx;
}
